"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCNPJ = void 0;
function validateCNPJ(value) {
    var clearValue = String(value).replace(/[^\d]+/g, '');
    if (clearValue === '')
        return false;
    if (clearValue.length !== 14)
        return false;
    if (clearValue === '00000000000000' ||
        clearValue === '11111111111111' ||
        clearValue === '22222222222222' ||
        clearValue === '33333333333333' ||
        clearValue === '44444444444444' ||
        clearValue === '55555555555555' ||
        clearValue === '66666666666666' ||
        clearValue === '77777777777777' ||
        clearValue === '88888888888888' ||
        clearValue === '99999999999999')
        return false;
    var length = clearValue.length - 2;
    var numbers = clearValue.substring(0, length);
    var digits = clearValue.substring(length);
    var sum = 0;
    var position = length - 7;
    for (var i = length; i >= 1; i -= 1) {
        sum += +numbers.charAt(length - i) * position;
        position -= 1;
        if (position < 2)
            position = 9;
    }
    var result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== +digits.charAt(0))
        return false;
    length += 1;
    numbers = clearValue.substring(0, length);
    sum = 0;
    position = length - 7;
    for (var i = length; i >= 1; i -= 1) {
        sum += +numbers.charAt(length - i) * position;
        position -= 1;
        if (position < 2)
            position = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== +digits.charAt(1))
        return false;
    return true;
}
exports.validateCNPJ = validateCNPJ;
